export default __webpack_public_path__ + "static/media/경북.7686bd2f.png";